import {Close, Check} from '@mui/icons-material'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography
} from '@mui/material'
import {useState} from 'react'
import {useTranslation} from 'react-i18next'

import {SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE} from '../../consts'

type TaskResolvedMandatoryCommentDialogProps = {
  open: boolean
  onClose: () => void
  onSubmit: (comment: string) => void
}

export const TaskResolvedMandatoryCommentDialog: React.FC<
  TaskResolvedMandatoryCommentDialogProps
> = ({open, onClose, onSubmit}) => {
  const {t} = useTranslation(SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE)
  const [mandatoryComment, setMandatoryComment] = useState<string>('')
  return (
    <Dialog data-test-id="task-resolved-mandatory-comment" open={open} onClose={() => onClose()}>
      <DialogTitle>{t('shiftEvent.form.changeTaskStatusTitle')}</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{mb: 2}}>
          <Typography gutterBottom>{t('shiftEvent.form.changeTaskStatusDescription')}</Typography>
        </DialogContentText>

        <TextField
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          multiline
          data-test-id="mandatory-comment-input"
          fullWidth
          label={t('shiftEvent.label.comment')}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setMandatoryComment(event.target.value)
          }
          value={mandatoryComment}
        />
      </DialogContent>
      <DialogActions>
        <Button
          startIcon={<Close />}
          onClick={onClose}
          color="primary"
          variant="text"
          data-test-id="cancel-mandatory-comment"
        >
          {t('action.cancel')}
        </Button>

        <Button
          startIcon={<Check />}
          onClick={() => {
            onSubmit(mandatoryComment)
          }}
          disabled={!mandatoryComment}
          variant="contained"
          data-test-id="confirm-mandatory-comment"
        >
          {t('action.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
